// @ts-nocheck

import Grid from "@mui/material/Grid";

// Soft UI Dashboard React components
import SoftBox from "../../components/common/softBox";

// Soft UI Dashboard React examples
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import MiniStatisticsCard from "../../components/cards/statisticsCards/miniStatisticsCard";
// import ReportsBarChart from "../../components/charts/barCharts/reportsBarChart";
// import GradientLineChart from "../../components/charts/lineCharts/gradientLineChart";



import PaidIcon from '@mui/icons-material/Paid';


// Data
import { FaHeadset, FaRegRectangleList, FaUserGroup } from "react-icons/fa6";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../Hooks";
import { getDashboardData } from "../../features/dashboard";

function Dashboard() {
  const { data } = useAppSelector((state: any) => state.dashboard);
const dispatch = useAppDispatch()
  useEffect(()=>{
    dispatch(getDashboardData())
  },[dispatch])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} lg={3}>
              <MiniStatisticsCard
                title={{ text: "Sale Order Requests" }}
                count={data?.salesOrder || 0}
                // percentage={{ color: "success", text: "+55%" }}
                icon={{ color: "primary", component: <FaRegRectangleList /> }}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <MiniStatisticsCard
                title={{ text: "Contact Inquiry Requests" }}
                count={data?.contactInquiry || 0}
                percentage={{ color: "success", }}
                icon={{ color: "primary", component: <FaHeadset /> }}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <MiniStatisticsCard
                title={{ text: "Credit Limit Requests" }}
                count={data?.creditLimit || 0}
                percentage={{ color: "error", }}
                icon={{ color: "primary", component: <PaidIcon /> }}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <MiniStatisticsCard
                title={{ text: "Total Users" }}
                count={data?.totalUser || 0}
                percentage={{ color: "success", }}
                icon={{
                  color: "primary",
                  component: <FaUserGroup />
                }}
              />
            </Grid>
          </Grid>
        </SoftBox>
        {/* <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={7}>
              <BuildByDevelopers />
            </Grid>
            <Grid item xs={12} lg={5}>
              <WorkWithTheRockets />
            </Grid>
          </Grid>
        </SoftBox> */}
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={5}>
              {/* <ReportsBarChart
                title="active users"
                description={
                  <>
                    (<strong>+23%</strong>) than last week
                  </>
                }
                chart={chart}
                items={items}
              /> */}
            </Grid>
            <Grid item xs={12} lg={7}>
              {/* <GradientLineChart
                title="Sales Overview"
                description={
                  <SoftBox display="flex" alignItems="center">
                    <SoftBox fontSize={size.lg} color="success" mb={0.3} mr={0.5} lineHeight={0}>
                      <Icon className="font-bold">arrow_upward</Icon>
                    </SoftBox>
                    <SoftTypography variant="button" color="text" fontWeight="medium">
                      4% more{" "}
                      <SoftTypography variant="button" color="text" fontWeight="regular">
                        in 2021
                      </SoftTypography>
                    </SoftTypography>
                  </SoftBox>
                }
                height="20.25rem"
                chart={gradientLineChartData}
              /> */}
            </Grid>
          </Grid>
        </SoftBox>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={8}>
            {/* <Projects /> */}
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            {/* <OrderOverview /> */}
          </Grid>
        </Grid>
      </SoftBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Dashboard;
